import { ImportSpreadsheetErrors } from '../quiz/importQuiz';

export const validSpreadsheetMime = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/octet-stream',
] as const;

type ValidMimeType = typeof validSpreadsheetMime[number];

export function checkForSpreadsheetMimeType(type: string) {
  if (!validSpreadsheetMime.includes(type as ValidMimeType)) {
    throw new Error(
      ImportSpreadsheetErrors[ImportSpreadsheetErrors.INVALID_FILE_TYPE]
    );
  }
}
